import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchInvesmentMonthlyReport = createAsyncThunk(
  "investmentMonthlyReport/fetchInvesmentMonthlyReport",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/investment/generate-monthly-report", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "applictaion/json",
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const investmentMonthlyReportSlice = createSlice({
  name: "investmentMonthlyReport",
  initialState: {
    investmentMonthlyReports: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvesmentMonthlyReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchInvesmentMonthlyReport.fulfilled, (state, action) => {
        state.status = "success";
        state.investmentMonthlyReports = action.payload.data;
      })
      .addCase(fetchInvesmentMonthlyReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default investmentMonthlyReportSlice.reducer;
